export default __webpack_public_path__ + "static/media/kr.d364f21e.svg";